<template>
    <div>
        <v-dialog max-width="80%" v-model="computed_dialog">
            <app-card>
                <h4>CHỈNH SỬA PHIẾU SỬA CHỮA</h4>
                <v-form ref="form">
                    <v-container fluid>
                        <v-layout row wrap>
                            <v-flex xs12 md3>
                                <v-menu :close-on-content-click="false" v-model="menu_registration_date"
                                    :nudge-right="40" lazy transition="scale-transition" offset-y full-width
                                    min-width="290px">
                                    <v-text-field slot="activator" v-model="form.registration_date"
                                        label="Ngày tạo phiếu"
                                        :disabled="loading.submit || chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH"
                                        prepend-icon="event" readonly :rules="[rules.required]"></v-text-field>
                                    <v-date-picker locale="vi-VI" v-model="form.registration_date"
                                        @input="menu_registration_date = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select label="Tòa nhà"
                                    :disabled="loading.submit || chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH"
                                    v-model="form.building" :items="list_building" prepend-icon="domain" :rules="[rules.required]
                                        " @change="form.room_id = ''" required></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field label="Số chứng từ giấy" v-model="form.receipt_code"
                                    :disabled="loading.submit || chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-text-field label="Mã chứng từ" v-model="form.receipt_id" disabled></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-autocomplete label="Số phòng"
                                    :disabled="loading.submit || chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH"
                                    v-model="form.room_id" :items="room_ids" item-text="room_id" item-value="rooms_id"
                                    prepend-icon="meeting_room" :rules="[rules.required]" required></v-autocomplete>
                            </v-flex>
                            <v-flex v-if="form.room_id === 'Khác'" xs12 md3>
                                <v-text-field v-model="form.customRoomId" label="Nhập số phòng"
                                    :rules="[rules.required]" required
                                    :disabled="loading.submit || chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH"></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-select label="Thợ sửa chữa" 
                                    :disabled="loading.submit || chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH"
                                    v-model="form.repairman_name" :items="repairmen_name" prepend-icon="person_pin"></v-select>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-menu :close-on-content-click="false" v-model="menu_scheduled_date" :nudge-right="40" lazy
                                    transition="scale-transition" offset-y full-width min-width="290px">
                                    <v-text-field slot="activator" v-model="form.scheduled_date" label="Ngày hẹn sửa"
                                        :disabled="loading.submit || chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH"
                                        prepend-icon="event" readonly></v-text-field>
                                    <v-date-picker locale="vi-VI" v-model="form.scheduled_date"
                                        @input="menu_scheduled_date = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field label="Nội dung yêu cầu" v-model="form.content" prepend-icon="event_note"
                                    :disabled="loading.submit || chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH"
                                    :rules="[rules.required]" required></v-text-field>
                            </v-flex>
                            <v-flex xs12 md3>
                                <v-menu :close-on-content-click="false" v-model="menu_completion_date" :nudge-right="40"
                                    lazy transition="scale-transition" offset-y full-width min-width="290px">
                                    <v-text-field slot="activator" v-model="form.completion_date"
                                        label="Ngày hoàn thành"
                                        :disabled="loading.submit || chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH"
                                        prepend-icon="event" readonly></v-text-field>
                                    <v-date-picker locale="vi-VI" v-model="form.completion_date"
                                        @input="menu_completion_date = false"></v-date-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout>
                    </v-container>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :loading="loading.submit"
                            :disabled="loading.submit || alert.show || chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH"
                            @click="submit" color="green" class="white--text">
                            Chỉnh sửa
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </app-card>
        </v-dialog>
    </div>
</template>

<script>
import { Wallet } from 'Components/Form';
import { list_building, REPAIR_REQUEST_STATUS } from 'Constants/db-config';
import api from '../../api';

export default {
    name: "dialog-tao-phieu-sua-chua",
    components: {
        Wallet
    },
    props: {
        chosen_repair_request: Object,
        dialog: Boolean,
        repairmen_name: Array
    },
    data() {
        return {
            computed_dialog: false,
            menu_registration_date: false,
            menu_completion_date: false,
            menu_scheduled_date: false,
            loading: {
                submit: false
            },
            form: {
                registration_date: "",
                building: "",
                receipt_code: "",
                receipt_id: "",
                room_id: "",
                content: "",
                customRoomId: "",
                repairman_name: "",
                scheduled_date: ""
            },
            list_building,
            rules: {
                required: value => !!value || 'Vui lòng điền thông tin này.',
            },
            alert: {
                show: false,
                text: '',
                type: 'error'
            },
            REPAIR_REQUEST_STATUS,
        }
    },
    computed: {
        rooms() {
            return this.$store.state.app.rooms
        },
        room_ids() {
            return ["Khác", ...this.rooms.filter(room => room.building === this.form.building)]
        },
    },
    watch: {
        // dialog: prop nhận từ cha (readonly)
        // computed_dialog: dialog state
        //  -> khi thay đổi thì emit 'changeDialogState' về cha để cập nhật lại trigger
        computed_dialog(nv) {
            if (!nv) {
                this.$emit('changeDialogState', nv)
                this.clearInput()
            }
        },
        dialog(nv) {
            this.computed_dialog = nv
            if (nv && this.chosen_repair_request) {
                for (const key in this.chosen_repair_request) {
                    if (this.chosen_repair_request.hasOwnProperty(key)) {
                        switch (key) {
                            case "registration_date":
                            case "completion_date":
                            case "scheduled_date":
                                this.form[key] = this.chosen_repair_request[key] && this.chosen_repair_request[key].substr(0, 10)
                                break;
                            default:
                                this.form[key] = this.chosen_repair_request[key];
                        }
                    }
                }
            }
        },
        "form.receipt_code"(nv) {
            if (nv && this.form.building) {
                const buildingCode = this.form.building === 'MT' ? 'MA' : this.form.building;
                this.form.receipt_id = buildingCode + '.' + nv + ".SC";
            }
        },
        "form.building"(nv) {
            if (nv && this.form.receipt_code) {
                const buildingCode = nv === 'MT' ? 'MA' : nv;
                this.form.receipt_id = buildingCode + '.' + this.form.receipt_code + ".SC";
            }
        }
    },
    methods: {
        clearInput: function () {
            this.$refs.form.reset()
        },
        submit: async function () {
            if (this.chosen_repair_request.status === REPAIR_REQUEST_STATUS.DA_HOAN_THANH) {
                return;
            }

            if (!this.$refs.form.validate()) {
                swal.fire('Lỗi', 'Vui lòng điền đầy đủ thông tin', 'error');
                return
            }
            const postData = {
                ...this.form,
                room_id: this.form.room_id === "Khác" ? this.form.customRoomId : this.form.room_id
            }

            this.loading.submit = true
            const data = await api.updateRepairRequest(postData);
            this.loading.submit = false
            if (data.status === 200) {
                this.computed_dialog = false
                swal.fire('Thành công', data.data.message, 'success')
                this.$emit('reloadTable');
                this.clearInput()
            } else {
                swal.fire('Lỗi', data.message, 'error')
            }
        }
    }
}
</script>

<style></style>